import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowRightFromRectangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 22H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h6c2.21 0 4 1.79 4 4v2c0 .55-.45 1-1 1s-1-.45-1-1V6c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 2.21-1.79 4-4 4"
    />
    <path
      fill="currentColor"
      d="M18.16 15.84c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41L18.585 13H9.63c-.55 0-1-.45-1-1s.45-1 1-1h8.955L17.45 9.86a.996.996 0 1 1 1.41-1.41l2.803 2.803a.998.998 0 0 1-.057 1.541L18.86 15.54c-.2.2-.45.29-.71.29z"
    />
  </svg>
);
export default SvgArrowRightFromRectangle;
